module.exports = __webpack_public_path__ + "static/media/empresariales1-min.81a52c2e.jpg";